<template>
  <v-menu
    v-bind="menuProps"
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
    @update:return-value="update"
  >
    <template #activator="{ on }">
      <v-text-field
        v-on="on"
        v-model="fullTimeValue"
        v-bind="$attrs"
        readonly
        prepend-inner-icon="mdi-calendar"
      ></v-text-field>
    </template>

    <v-card>
      <v-date-picker
        v-bind="datePickerProps"
        v-model="date"
        :active-picker.sync="activePicker"
        :range="range"
        color="Primary"
        class="b-rad-0"
        locale="zh-CN"
        flat
      ></v-date-picker>

      <div v-if="withTime">
        <div
          v-if="range"
          class="d-flex px-4 align-center justify-space-between"
        >
          <div>
            <v-icon :disabled="i === 0" @click="i = 0">mdi-chevron-left</v-icon>
          </div>
          {{ parseTimeText }}
          <div>
            <v-icon :disabled="i === 1" @click="i = 1">
              mdi-chevron-right
            </v-icon>
          </div>
        </div>
        <v-window v-model="i" touchless>
          <v-window-item :value="0">
            <v-time-picker
              v-bind="timePickerProps"
              v-model="time"
              scrollable
              class="b-rad-0"
              format="24hr"
            ></v-time-picker>
          </v-window-item>

          <v-window-item v-if="range" :value="1">
            <v-time-picker
              v-bind="timePickerProps"
              v-model="timeEnd"
              scrollable
              class="b-rad-0"
              format="24hr"
            ></v-time-picker>
          </v-window-item>
        </v-window>
      </div>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">保存</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    menuProps: {
      tpye: Object,
      default: () => ({})
    },
    datePickerProps: {
      tpye: Object,
      default: () => ({})
    },
    timePickerProps: {
      tpye: Object,
      default: () => ({})
    },
    year: {
      type: Boolean,
      default: false
    },
    withTime: {
      type: Boolean,
      default: false
    },
    range: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    i: 0, // time page
    activePicker: null,
    fullTimeValue: '',
    date: null,
    time: null,
    timeEnd: null,
    menu: false
  }),

  computed: {
    parseTimeText() {
      if (this.i === 0) return '開始';
      if (this.i === 1) return '結束';
      return '';
    }
  },

  watch: {
    menu(v) {
      this.year && v && setTimeout(() => (this.activePicker = 'YEAR'));
    },
    fullTimeValue(v) {
      this.$emit('input', v && v.length ? v : null);
    }
  },

  methods: {
    save() {
      let date = this.date || moment().format('YYYY-MM-DD');
      const time = this.time || `00:00`;
      const timeEnd = this.timeEnd || `00:00`;
      if (Array.isArray(date)) {
        this.fullTimeValue = date.map((el, i) =>
          this.withTime ? `${el} ${i ? timeEnd : time}` : `${el}`
        );
      } else {
        this.fullTimeValue = this.withTime ? `${date} ${time}` : `${date}`;
      }
      this.$refs.menu.save(this.fullTimeValue);
    },
    update(v) {
      if (!v && !this.fullTimeValue) {
        this.i = 0;
        this.date = null;
        this.time = null;
        this.timeEnd = null;
      }
    }
  }
};
</script>

<style></style>
